export default function (html: string) {
    let words = html.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, ""); //这里是去除标签
    return words.replace(/\s/g, "") //这里是去除空格
}